module.exports = __webpack_public_path__ + "img/success-case.af1c9e49.png";